import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

import MaintenanceDashboardBlock from './MaintenanceDashboardBlock';

const ProjectNameLogoBlock = ({ projectName, customerLogoUrl, t }) => (
  <Box position='relative' height='100%'>
    <MaintenanceDashboardBlock
      title={projectName || t('no_project_selected')}
      icon={<BusinessIcon />}
      className='project-name-logo-block'
    >
      {customerLogoUrl && (
        <Box
          component='img'
          src={customerLogoUrl}
          alt='Customer Logo'
          sx={{
            maxWidth: '120px',
            maxHeight: '80px',
            objectFit: 'contain',
          }}
        />
      )}
    </MaintenanceDashboardBlock>
  </Box>
);

ProjectNameLogoBlock.propTypes = {
  projectName: PropTypes.string,
  customerLogoUrl: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default ProjectNameLogoBlock;
